import React from 'react';
import {
  TextField,
  Typography
} from '@mui/material';
import { Controller, useFormContext, FieldErrors } from 'react-hook-form';
import { ParentRegisterData } from '../../../../../types/auth';

const ParentPersonalStep = () => {
  const { control, formState: { errors } } = useFormContext<ParentRegisterData>();

  // Properly typed errors
  const parentDataErrors = errors.parentData as FieldErrors<ParentRegisterData['parentData']> | undefined;

  return (
    <>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'medium', color: 'secondary.main' }}>
        Parent Personal Information
      </Typography>

      <Controller
        name="parentData.firstName"
        control={control}
        rules={{
          required: 'First name is required',
        }}
        render={({ field }) => (
          <TextField
            {...field}
            margin="normal"
            required
            fullWidth
            id="parentFirstName"
            label="First Name"
            autoComplete="given-name"
            error={!!parentDataErrors?.firstName}
            helperText={parentDataErrors?.firstName?.message}
            inputProps={{ 'data-testid': 'parent-firstName-input' }}
          />
        )}
      />

      <Controller
        name="parentData.lastName"
        control={control}
        rules={{
          required: 'Last name is required',
        }}
        render={({ field }) => (
          <TextField
            {...field}
            margin="normal"
            required
            fullWidth
            id="parentLastName"
            label="Last Name"
            autoComplete="family-name"
            error={!!parentDataErrors?.lastName}
            helperText={parentDataErrors?.lastName?.message}
            inputProps={{ 'data-testid': 'parent-lastName-input' }}
          />
        )}
      />
    </>
  );
};

export default ParentPersonalStep;
